import "../components/global.js";
import "../assets/css/bootstrap.css";
import Navbar from "../components/Navbar.js";
import Select from "react-select";
import Swal from "sweetalert2";
import { loading, tokens, select_style, success, GET, POST, PUT, DELETE, format_date, number, float, required, DatePicker, getStorage } from "../components/CustomComponent.js";
import { report_customer_1 } from "../components/ReportCustomer01.js";
import { report_customer_2 } from "../components/ReportCustomer02.js";
import { report_customer_3 } from "../components/ReportCustomer03.js";
import React, { Component } from "react";
import Pagination from "@mui/material/Pagination";
import { Modal } from "react-bootstrap";
import { ReactExcel, readFile, generateObjects } from "@ramonak/react-excel";
import excel_file from "../assets/files/import_customer.xlsx";

const role = getStorage("role_detail");
const select_role = role ? role.find((item) => item.name === "record-water-usage") : null;
const view_r = select_role && select_role.role[0] === 1;

const STAT_TRANS = [
  { value: 1, label: "โอนกรรมสิทธิ์แล้ว" },
  { value: 2, label: "ยังไม่โอนกรรมสิทธิ์" },
  { value: 3, label: "ห้องว่าง" },
];
const STAT_BUY = [
  { value: 1, label: "เงินสด" },
  { value: 2, label: "ผ่อนชำระกับธนาคาร" },
  { value: 3, label: "ผู้เช่าซื้อกับการเคหะแห่งชาติ" },
  { value: 4, label: "ซื้อต่อกับลูกค้าเดิม" },
  { value: 5, label: "อื่น ๆ" },
];

const initialForm = {
  customer_id: "", full_name: "", id_card: "", address: "", home_phone: "", mobile_phone: "",
  delivery_date: "", receive_date: "", transfer_date: "", status_transfer: null,
  loan_number: "", credit_limit: "", installment: "", contract_date: "",
  status_buy_building: null, address_number: "", building: "", floor: "", room_size: "",
};

export default class Export extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false, modal_update: false, modal_delete: false, modal_import: false,
      page: 1, filter_data_search: "", filter_transfer_date: "", filter_status_transfer: null,
      data: null, summary: null, file_import: null, currentSheet: null, over: false, data_import: null,
      form: { ...initialForm },
    };
  }

  async componentDidMount() {
    loading(false);
    if (view_r) await this.GetAll();
  }

  GetAll = async () => {
    loading(true);
    let { filter_data_search, filter_transfer_date, filter_status_transfer, page } = this.state;
    let data = {
      data_search: filter_data_search,
      transfer_date: filter_transfer_date,
      status_transfer: filter_status_transfer?.value || "",
    };
    let result = await GET(tokens, "v1/TH/customer-manage/filter-search/page/" + page + "/" + getStorage("project_id"), data);
    if (result?.status) this.setState({ data: result.data });
    loading(false);
    // ตัวเลขสรุปสถานะ (เดิม hardcode) — ดึงชุดเดียวกับตัวกรองแบบไม่แบ่งหน้า (page 0) เหมือนหน้า /customer
    let result_all = await GET(tokens, "v1/TH/customer-manage/filter-search/page/0/" + getStorage("project_id"), data);
    if (Array.isArray(result_all?.data?.data)) {
      const d = result_all.data.data;
      this.setState({
        summary: {
          total: d.length,
          transfer: d.filter((e) => e.status_transfer === 1).length,
          not_transfer: d.filter((e) => e.status_transfer === 2).length,
          blank_room: d.filter((e) => e.status_transfer === 3).length,
        },
      });
    }
  };

  getPayload = () => {
    const { form } = this.state;
    return {
      ...form,
      credit_limit: parseFloat(form.credit_limit) || 0,
      installment: parseFloat(form.installment) || 0,
      status_transfer: form.status_transfer?.value || "",
      status_buy_building: form.status_buy_building?.value || "",
      floor: Number(form.floor) || 0,
      room_size: Number(form.room_size) || 0,
    };
  };

  Create = async () => {
    loading(true);
    let result = await POST(tokens, "v1/TH/customer-manage/create/" + getStorage("project_id"), { customer_list: [this.getPayload()] });
    if (result?.status) { this.clear_form(); success(); this.GetAll(); }
    loading(false);
  };

  Create_Import = async () => {
    loading(true);
    let result = await POST(tokens, "v1/TH/customer-manage/create/" + getStorage("project_id"), { customer_list: this.state.data_import });
    if (result?.status) { this.clear_form(); success(); this.GetAll(); }
    loading(false);
  };

  Update = async () => {
    loading(true);
    let result = await PUT(tokens, "v1/TH/customer-manage/update", this.getPayload());
    if (result?.status) { this.clear_form(); success(); this.GetAll(); }
    loading(false);
  };

  Delete = async () => {
    loading(true);
    let result = await DELETE(tokens, "v1/TH/customer-manage/delete/" + this.state.form.customer_id, null);
    if (result?.status) { this.clear_form(); success(); this.GetAll(); }
    loading(false);
  };

  clear_form = () => {
    this.setState({
      modal_create: false, modal_update: false, modal_delete: false, modal_import: false,
      page: 1, filter_data_search: "", filter_transfer_date: "", filter_status_transfer: null,
      file_import: null, currentSheet: null, over: false, data_import: null,
      form: { ...initialForm }
    });
  };

  Import_file = (e) => {
    readFile(e.target.files[0]).then((readedData) => {
      this.setState({ file_import: readedData });
      setTimeout(this.Import, 10);
    }).catch(console.error);
    e.target.value = "";
  };

  Import = () => {
    const statTransMap = { "โอนกรรมสิทธิ์แล้ว": 1, "ยังไม่โอนกรรมสิทธิ์": 2, "ห้องว่าง": 3 };
    const statBuyMap = { "เงินสด": 1, "ผ่อนชำระกับธนาคาร": 2, "ผู้เช่าซื้อกับการเคหะแห่งชาติ": 3, "ซื้อต่อกับลูกค้าเดิม": 4, "อื่น ๆ": 5 };
    
    let data = generateObjects(this.state.currentSheet)
      .filter((item) => item["ชื่อ - สกุล"])
      .map((item) => ({
        full_name: item["ชื่อ - สกุล"], id_card: item["เลขบัตรประชาชน"], address: item["ที่อยู่"],
        home_phone: item["โทรศัพท์บ้าน"], mobile_phone: item["โทรศัพท์มือถือ"],
        delivery_date: item["วันที่ส่งมอบ"], receive_date: item["วันที่มารับมอบ"], transfer_date: item["วันที่โอน"],
        status_transfer: statTransMap[item["สถานะการโอน"]] || null,
        loan_number: item["เลขที่เงินกู้"], credit_limit: item["วงเงินกู้"], installment: item["เงินงวด"],
        contract_date: item["วันที่ทำสัญญา"], status_buy_building: statBuyMap[item["ซื้ออาคารโดย"]] || null,
        address_number: item["บ้านเลขที่"], building: item["อาคาร"], floor: item["ชั้น"], room_size: item["ขนาดห้อง (ตรม.)"],
      }));
    data.shift(); // Remove template header row
    this.setState({ data_import: data });
  };

  drop_file = (e) => {
    e.preventDefault();
    readFile(e.dataTransfer.items[0].getAsFile()).then((readedData) => {
      this.setState({ file_import: readedData, over: false });
      setTimeout(this.Import, 10);
    }).catch(console.error);
  };

  // Helper function ลดบรรทัด Code
  hForm = (field, val) => this.setState(prev => ({ form: { ...prev.form, [field]: val } }));
  
  RInput = (label, field, opts = {}) => {
    const { form } = this.state;
    return (
      <div className="w-100 d-flex align-items-center mb-3">
        <label className="wpx-140">{label}{opts.req ? required : ":"}</label>
        <input
          className={`form-control border-0 bg-contain ${opts.req ? 'validate' : ''}`}
          type={opts.type || "text"} placeholder="กรอกข้อมูล" maxLength={opts.max} value={form[field]}
          onChange={(e) => {
            let val = e.target.value;
            if (opts.num) val = number(val);
            if (opts.float && !float(val) && val !== "") return;
            this.hForm(field, val);
          }}
        />
      </div>
    );
  };

  RDate = (label, field) => (
    <div className="w-100 d-flex align-items-center mb-3">
      <label className="wpx-140">{label}:</label>
      <DatePicker className="form-control bg-contain border-0 w-100" placeholder="พิมพ์คำค้นหา..." 
        value={this.state.form[field]} onChange={(e) => this.hForm(field, e)} />
    </div>
  );

  RSelect = (label, field, options) => (
    <div className="w-100 d-flex align-items-center mb-3">
      <label className="wpx-140">{label}:</label>
      <Select className="form-control bg-contain border-0 select-search" styles={select_style} 
        options={options} value={this.state.form[field]} onChange={(e) => this.hForm(field, e)} />
    </div>
  );

  render() {
    let { data, filter_data_search, filter_transfer_date, filter_status_transfer, data_import, form, summary } = this.state;
    const array_data = data?.data || [];

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="รายชื่อลูกค้า" />
        <div className="body">
          <div className="p-3">
            <div className="card border-0 p-3">
              <div className="d-flex row mx-0 align-items-center justify-content-between">
                <h4 className="mb-3"><b>รายชื่อลูกค้า</b></h4>
                <div className="d-flex row mx-0">
                  <button className="btn btn-outline-primary mx-1 mb-3" onClick={() => report_customer_1(array_data)}>รายงานลูกค้าที่โอนกรรมสิทธิ์</button>
                  <button className="btn btn-outline-primary mx-1 mb-3" onClick={() => report_customer_2(array_data)}>รายงานลูกค้าที่ยังไม่โอน</button>
                  <button className="btn btn-outline-primary mx-1 mb-3" onClick={() => report_customer_3(array_data)}>รายงานห้องว่าง</button>
                  <button className="btn btn-blue px-4 mx-1 text-light mb-3" onClick={() => { this.clear_form(); this.setState({ modal_import: true }); }}>นำเข้าข้อมูลลูกค้า</button>
                  <button className="btn btn-primary px-4 mx-1 mb-3" onClick={() => { this.clear_form(); this.setState({ modal_create: true }); }}>เพิ่มข้อมูลลูกค้า</button>
                </div>
              </div>

              <div className="d-flex row mx-0 align-items-center justify-content-between">
                <div className="d-flex row mx-0">
                  <input type="search" className="form-control wpx-200 bg-contain border-0 mx-1 mb-3" placeholder="พิมพ์คำค้นหา..." value={filter_data_search} onKeyUp={(e) => e.key === "Enter" && this.GetAll()} onChange={(e) => this.setState({ filter_data_search: e.target.value })} />
                  <div className="wpx-200 mx-1 mb-3"><DatePicker className="form-control bg-contain border-0" placeholder="พิมพ์คำค้นหา..." value={filter_transfer_date} onChange={(e) => this.setState({ filter_transfer_date: e }, this.GetAll)} /></div>
                  <div className="wpx-200 mx-1 mb-3"><Select className="form-control bg-contain border-0 select-search" styles={select_style} options={STAT_TRANS} isClearable value={filter_status_transfer} onChange={(e) => this.setState({ filter_status_transfer: e }, this.GetAll)} /></div>
                  <button className="btn btn-outline-primary px-3 mb-3" onClick={() => window.location.reload()}>รีเซ็ท</button>
                </div>
              </div>

              <div className="table-responsive">
                <table className="table table-borderless table-striped">
                  <thead>
                    <tr>
                      <td className="text-left"><b>หน่วยก่อสร้าง</b></td><td className="text-left">{summary ? summary.total : (data?.count || 0)}</td>
                      <td className="text-left"><b>โอนกรรมสิทธิ์แล้ว</b></td><td className="text-left">{summary ? summary.transfer : "-"}</td>
                      <td className="text-left"><b>ยังไม่โอน</b></td><td className="text-left">{summary ? summary.not_transfer : "-"}</td>
                      <td className="text-left"><b>ห้องว่าง</b></td><td className="text-left">{summary ? summary.blank_room : "-"}</td><td></td>
                    </tr>
                    <tr className="bg-dark-blue text-white">
                      <th className="text-left">อาคาร</th><th className="text-left">ชั้นที่</th><th className="text-left">บ้านเลขที่</th><th className="text-left">ชื่อ - นามสกุล</th>
                      <th className="text-center wpx-150">สถานะ</th><th className="text-left">วันที่โอน</th><th className="text-left">โทรศัพท์</th><th className="text-left">โทรศัพท์มือถือ</th><th className="text-center">จัดการ</th>
                    </tr>
                  </thead>
                  <tbody>
                    {array_data.length === 0 ? (<tr><td colSpan={9} className="text-center">ไม่มีข้อมูล</td></tr>) : 
                      array_data.map((item, i) => (
                        <tr key={"tr" + i}>
                          <td>{item.building || "-"}</td><td>{item.floor || "-"}</td><td>{item.address_number || "-"}</td><td>{item.full_name || "-"}</td>
                          <td className="text-center">
                            <span className={item.status_transfer === 1 ? "bg-primary rounded px-2 py-1 text-white" : item.status_transfer === 2 ? "bg-purple rounded px-2 py-1 text-white" : "bg-blue rounded px-2 py-1 text-white"}>
                              {STAT_TRANS.find(s => s.value === item.status_transfer)?.label || "-"}
                            </span>
                          </td>
                          <td>{item.transfer_date ? format_date(item.transfer_date) : "-"}</td>
                          <td>{item.home_phone || "-"}</td><td>{item.mobile_phone || "-"}</td>
                          <td className="text-center d-flex justify-content-center">
                            <label className="wpx-24 hpx-24 bg-primary-light rounded-1 d-flex align-items-center justify-content-center mr-2 icon text-primary pointer" 
                              onClick={() => this.setState({ modal_update: true, form: { ...item, status_transfer: STAT_TRANS.find(s => s.value === item.status_transfer) || null, status_buy_building: STAT_BUY.find(s => s.value === item.status_buy_building) || null } })}>
                              {"\uf304"}
                            </label>
                            <label className="wpx-24 hpx-24 bg-danger-light rounded-1 d-flex align-items-center justify-content-center icon text-danger pointer" 
                              onClick={() => this.setState({ modal_delete: true, form: { ...form, customer_id: item.customer_id } })}>
                              {"\uf2ed"}
                            </label>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
              {data && data.data.length !== 0 && (
                <div className="d-flex justify-content-between row mx-0 w-100 px-3">
                  <label>แสดง {data.start_index} - {data.end_index} รายการ จาก {data.count} รายการ</label>
                  <Pagination count={data.page_number} page={this.state.page} color="primary" showFirstButton showLastButton onChange={(e, v) => this.setState({ page: v }, this.GetAll)} />
                </div>
              )}
            </div>
          </div>
        </div>

        {/* MODAL Create/Update */}
        <Modal show={this.state.modal_create || this.state.modal_update} onHide={() => this.setState({ modal_create: false, modal_update: false })} dialogClassName="modal-w">
          <Modal.Header><Modal.Title><b>{this.state.modal_create ? "เพิ่มข้อมูลลูกค้า" : "แก้ไขข้อมูลลูกค้า"}</b></Modal.Title></Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-12 col-lg-6">
                {this.RInput("ชื่อ-นามสกุล", "full_name", { req: true })}
                {this.RInput("เลขบัตรประชาชน", "id_card", { req: true, num: true, max: 13 })}
                {this.RInput("ที่อยู่", "address", { req: true })}
                {this.RInput("ขนาดห้อง (ตรม.)", "room_size", { req: true, float: true, max: 13 })}
                {this.RInput("โทรศัพท์บ้าน", "home_phone", { num: true, max: 10 })}
                {this.RInput("โทรศัพท์มือถือ", "mobile_phone", { req: true, num: true, max: 10 })}
                {this.RDate("วันที่ส่งมอบ", "delivery_date")}
                {this.RDate("วันที่มารับมอบ", "receive_date")}
                {this.RDate("วันที่โอน", "transfer_date")}
              </div>
              <div className="col-12 col-lg-6">
                {this.RSelect("สถานะการโอน", "status_transfer", STAT_TRANS)}
                {this.RInput("เลขที่เงินกู้", "loan_number", { num: true })}
                {this.RInput("วงเงินกู้", "credit_limit", { float: true })}
                {this.RInput("เงินงวด", "installment", { float: true })}
                {this.RDate("วันที่ทำสัญญา", "contract_date")}
                {this.RSelect("ซื้ออาคารโดย", "status_buy_building", STAT_BUY)}
                {this.RInput("อาคาร", "building")}
                {this.RInput("ชั้น", "floor", { num: true })}
                {this.RInput("บ้านเลขที่", "address_number")}
              </div>
            </div>
            <div className="w-100 d-flex">
              <div className="w-50 p-1"><button className="btn btn-outline-primary w-100" onClick={() => this.setState({ modal_create: false, modal_update: false })}>ยกเลิก</button></div>
              <div className="w-50 p-1"><button className="btn btn-primary w-100" onClick={() => this.state.modal_create ? this.Create() : this.Update()}>{this.state.modal_create ? "เพิ่ม" : "บันทึก"}</button></div>
            </div>
          </Modal.Body>
        </Modal>

        {/* MODAL Delete */}
        <Modal show={this.state.modal_delete} onHide={() => this.setState({ modal_delete: false })}>
          <Modal.Header><Modal.Title><b>ยืนยันการลบข้อมูลลูกค้า</b></Modal.Title></Modal.Header>
          <Modal.Body>
            <label className="mb-3">ท่านแน่ใจว่าต้องการลบข้อมูลลูกค้า หลังจากท่านยืนยันการยกเลิกแล้วจะไม่สามารถย้อนคืนข้อมูลได้</label>
            <div className="w-100 d-flex">
              <div className="w-50 p-1"><button className="btn btn-outline-primary w-100" onClick={() => this.setState({ modal_delete: false })}>ยกเลิก</button></div>
              <div className="w-50 p-1"><button className="btn btn-danger w-100" onClick={this.Delete}>ยืนยัน</button></div>
            </div>
          </Modal.Body>
        </Modal>

        {/* MODAL Import */}
        <Modal show={this.state.modal_import} onHide={() => this.setState({ modal_import: false })} dialogClassName="modal-w100">
          <Modal.Header><Modal.Title><b>นำเข้าข้อมูลลูกค้า</b></Modal.Title></Modal.Header>
          <Modal.Body>
            {!data_import ? (
              <div className="w-100">
                <div className="w-100 text-right"><a className="text-secondary text-decoration-none mt-3" href={excel_file} download="import_customer.xlsx"><label className="icon">{"\uf65b"}</label> template นำเข้าข้อมูลลูกค้า</a></div>
                <div className="p-2 text-center">
                  <div className={`card p-3 border-0 text-center mb-3 ${this.state.over ? 'bg-blue-sky' : 'bg-contain'}`} onDrop={this.drop_file} onDragOver={(e) => { this.setState({ over: true }); e.preventDefault(); }} onDragLeave={(e) => { this.setState({ over: false }); e.preventDefault(); }}>
                    <label className="icon text-secondary" style={{ fontSize: 48 }}>{"\uf65b"}</label>
                    <label className="text-secondary">ลากและวางไฟล์ที่นี่</label><small className="text-secondary mb-3">หรือ</small>
                    <button className="btn btn-primary" onClick={() => document.getElementById("file").click()}>เลือกไฟล์</button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="table-responsive" style={{ height: "80vh", maxHeight: "80vh" }}>
                <table className="table table-borderless table-striped">
                  <thead>
                    <tr className="bg-dark-blue text-white">
                      {["ชื่อ - สกุล", "เลขบัตรประชาชน", "ที่อยู่", "โทรศัพท์บ้าน", "โทรศัพท์มือถือ", "วันที่ส่งมอบ", "วันที่มารับมอบ", "วันที่โอน", "สถานะการโอน", "เลขที่เงินกู้", "วงเงินกู้", "เงินงวด", "วันที่ทำสัญญา", "ซื้ออาคารโดย", "อาคาร", "ชั้น", "บ้านเลขที่", "ขนาดห้อง (ตรม.)", "ลบ"].map((th, i) => <th key={i} className="text-left">{th}</th>)}
                    </tr>
                  </thead>
                  <tbody>
                    {data_import.map((item, index) => (
                      <tr key={"tr" + index}>
                        <td className={item.full_name ? "text-left" : "bg-danger-light"}>{item.full_name || "-"}</td>
                        <td className={item.id_card ? "text-left" : "bg-danger-light"}>{item.id_card || "-"}</td>
                        <td className={item.address ? "text-left" : "bg-danger-light"}>{item.address || "-"}</td>
                        <td>{item.home_phone || "-"}</td>
                        <td className={item.mobile_phone ? "text-left" : "bg-danger-light"}>{item.mobile_phone || "-"}</td>
                        <td>{item.delivery_date || "-"}</td><td>{item.receive_date || "-"}</td><td>{item.transfer_date || "-"}</td>
                        <td className={item.status_transfer ? "text-left" : "bg-danger-light"}>{STAT_TRANS.find(s => s.value === item.status_transfer)?.label || "-"}</td>
                        <td>{item.loan_number || "-"}</td><td>{item.credit_limit || "-"}</td><td>{item.installment || "-"}</td><td>{item.contract_date || "-"}</td>
                        <td className={item.status_buy_building ? "text-left" : "bg-danger-light"}>{STAT_BUY.find(s => s.value === item.status_buy_building)?.label || "-"}</td>
                        <td className={item.address_number ? "text-left" : "bg-danger-light"}>{item.address_number || "-"}</td>
                        <td className={item.building ? "text-left" : "bg-danger-light"}>{item.building || "-"}</td>
                        <td className={item.floor ? "text-left" : "bg-danger-light"}>{item.floor || "-"}</td>
                        <td className={item.room_size ? "text-left" : "bg-danger-light"}>{item.room_size || "-"}</td>
                        <td><label className="wpx-24 hpx-24 bg-danger-light rounded-1 d-flex align-items-center justify-content-center icon text-danger pointer" onClick={() => this.setState({ data_import: data_import.filter((_, i) => i !== index).length ? data_import.filter((_, i) => i !== index) : null })}>{"\uf2ed"}</label></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            
            <input className="d-none" type="file" id="file" accept=".xls,.xlsx" onChange={this.Import_file} />
            <div className="d-none"><ReactExcel initialData={this.state.file_import} onSheetUpdate={(s) => this.setState({ currentSheet: s })} activeSheetClassName="d-none" reactExcelClassName="table table-borderless table-striped" /></div>
            
            <div className="w-100 d-flex mt-3">
              {!data_import ? (
                <button className="btn btn-outline-primary w-100" onClick={() => this.setState({ modal_import: false })}>ปิดหน้าต่าง</button>
              ) : (
                <>
                  <div className="p-1 w-33"><button className="btn btn-outline-primary w-100" onClick={() => this.setState({ modal_import: false })}>ยกเลิก</button></div>
                  <div className="p-1 w-33"><button className="btn btn-danger w-100" onClick={() => this.setState({ data_import: null })}>ล้างค่า</button></div>
                  <div className="p-1 w-33"><button className="btn btn-primary w-100" onClick={this.Create_Import}>นำเข้า</button></div>
                </>
              )}
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}